import { EditItem, IEditItem } from "../common/editItem";
import { DatabaseRecordType } from "../enums";
import { IModifyUser, ModifyUser } from "../user/modifyUser";

export interface ICalendarTaskCategoryEditItem extends IEditItem {
    code: string;
    comment: string;
    color: string;
    sortOrder: number;
    databaseRecordType: DatabaseRecordType;
    activeState: number;
    modifyUser: IModifyUser;
}

export class CalendarTaskCategoryEditItem extends EditItem implements ICalendarTaskCategoryEditItem {
    code: string;
    comment: string;
    color: string;
    sortOrder: number;
    databaseRecordType: DatabaseRecordType;
    activeState: number;
    modifyUser: ModifyUser;

    constructor();
    constructor(obj: ICalendarTaskCategoryEditItem);
    constructor(obj?: any) {
        super(obj);
        this.code = obj && obj.code || "";
        this.comment = obj && obj.comment || "";
        this.color = obj && obj.color || "";
        this.sortOrder = obj && obj.sortOrder || 0;
        this.databaseRecordType = obj?.databaseRecordType;
        this.activeState = obj && obj.activeState || 0;
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }
}